import {OnBoardingPageLoad} from '@/modules/onboarding/pages';

export default {
  Onboarding: {
    exact: true,
    path: '/onboarding',
    component: OnBoardingPageLoad
  }
};
